<template>
  <v-container>
    <v-toolbar>
      <v-spacer/>
      <v-btn @click="newTableModal">New Table</v-btn>
    </v-toolbar>
    <v-data-table
      :headers="headers"
      :items="tables"
    >
      <template v-slot:[`item.name`]="{ item }">
        <router-link :to="`/tables/${item._id}`">{{ item.name }}</router-link>
      </template>
      <template v-slot:[`item.actions`]="{ item }">
        <v-btn icon color="primary" @click="editTableModal(item)">
          <v-icon>mdi-pencil</v-icon>
        </v-btn>
        <v-btn icon color="error" @click="deleteTableModal(item)">
          <v-icon>mdi-delete</v-icon>
        </v-btn>
      </template>
    </v-data-table>
    <v-dialog v-model="new_table_modal" width="50%">
      <TableForm
        :table="new_table"
        @close="new_table_modal = !new_table_modal"
      />
    </v-dialog>
    <v-dialog v-model="edit_table_modal" width="50%">
      <TableForm
        :table="edit_table"
        :editing="true"
        @close="edit_table_modal = !edit_table_modal"
      />
    </v-dialog>
    <v-dialog v-model="delete_table_modal" width="50%">
      <v-card>
        Are sure you want to delete this table? ({{ delete_table_obj? delete_table_obj.name  : ''}})
        <v-card-actions>
          <v-spacer/>
          <v-btn @click="delete_table_modal = !delete_table_modal">Cancel</v-btn>
          <v-btn
              :loading="isLoading1"
              color="error"
              @click="deleteTable(delete_table_obj)">Delete</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import TableForm from "@/components/forms/TableForm";
export default {
  name: "TablesView",
  components: {TableForm},
  data() {
    return {
      new_table_modal: false,
      delete_table_modal: false,
      edit_table_modal: false,
      new_table: {
        name: '',
        event_datetime: '',
        min_stake: 0,
        status: 'UPCOMING',
        players: [],
        waiting_list: [],
        created_by: this.$store.getters.user._id
      },
      delete_table_obj: null,
      edit_table: null,
      headers: [
        { text: 'Table', value: 'name'},
        { text: 'No. of players', value: 'players.length'},
        { text: 'Waiting list', value: 'waiting_list.length'},
        { text: 'Event Date Time', value: 'event_datetime'},
        { text: 'Status', value: 'status'},
        { text: 'Actions', value: 'actions'},
      ]
    }
  },
  methods: {
    newTableModal() {
      this.new_table_modal = !this.new_table_modal
    },
    editTableModal(item) {
      this.edit_table = null
      this.edit_table = item
      this.edit_table_modal = !this.edit_table_modal
    },
    deleteTableModal(item) {
      this.delete_table_obj = null
      this.delete_table_obj = item
      this.delete_table_modal = !this.delete_table_modal
    },
    async deleteTable(item) {
      await this.$store.dispatch('DELETE_TABLE', { _id: item._id })
      this.delete_table_modal = !this.delete_table_modal
    },
  },
  computed: {
    tables() {
      return this.$store.getters.tables
    },
    isLoading1() {
      return this.$store.getters.isLoading1
    }
  },
  watch: {
    tables: function (v) { return v || [] },
    isLoading1(v) {
      return v
    }
  },
  created() {
    console.log(this.$store.getters.user)
    this.$store.dispatch('GET_TABLES')
    this.$store.commit('setIsLoading1', false)
  }
}
</script>

<style scoped>

</style>